import { format as formatUrl, UrlObject } from 'url';

import { domains } from '@/config/locales';
import { isSSR } from '@/utility/isSSR';

export const isExternalLink = (href: UrlObject | string | undefined): boolean => {
  if (!href) {
    return false;
  }

  try {
    const outdoorsyDomains = [
      new URL(process.env.hostApp || 'https://www.staging.outdoorsy.com').host,
      ...(isSSR() ? [] : [new URL(window.location.href).host]),
      ...domains,
    ];
    let linkUrl: URL;

    if (typeof href === 'string') {
      linkUrl = new URL(href, process.env.hostApp);
    } else {
      const formattedUrl = formatUrl(href);
      linkUrl = new URL(formattedUrl, process.env.hostApp);
    }

    return !outdoorsyDomains.includes(linkUrl.host);
  } catch {
    return false;
  }
};
